const stickyNoteBase = 'sticky-note-widget';

export const StickyNoteTrackingIds = {
  viewStickyArchive: `${stickyNoteBase}-view-sticky-archive`,
  newSticky: `${stickyNoteBase}-new-sticky`,
};
